import { html } from '@microsoft/fast-element';
import { ThirdParty } from './third-party';
import { EditThirdParty } from './edit/edit';

EditThirdParty;

export const ThirdPartyTemplate = html<ThirdParty>`
  <entity-management
    resourceName=${(x) => x.resourceName}
    modal-position="centre"
    entityLabel=${(x) => x.entityLabel}
    updateEvent="EVENT_RESURETY_REMAP_CHANGE_VERSION"
    :columns=${(x) => [...x.columns]}
    :datasourceConfig=${(x) => x.datasourceConfig}
    :permissions=${(x) => x.permissions}
    :gridOptions=${(x) => x.gridOptions}
  >
    <edit-third-party entityLabel=${(x) => x.entityLabel} slot="edit"></edit-third-party>
  </entity-management>
`;
